var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92857 1.36426H15.2143C16.1236 1.36426 16.9957 1.72548 17.6387 2.36846C18.2816 3.01144 18.6429 3.88352 18.6429 4.79283V11.65C18.6429 12.5593 18.2816 13.4314 17.6387 14.0743C16.9957 14.7173 16.1236 15.0785 15.2143 15.0785H4.92857C4.01926 15.0785 3.14719 14.7173 2.50421 14.0743C1.86122 13.4314 1.5 12.5593 1.5 11.65V4.79283C1.5 3.88352 1.86122 3.01144 2.50421 2.36846C3.14719 1.72548 4.01926 1.36426 4.92857 1.36426ZM18.6429 6.50712L22.7571 3.4214C23.0118 3.23038 23.3147 3.11406 23.6318 3.08547C23.9488 3.05688 24.2676 3.11715 24.5524 3.25953C24.8371 3.4019 25.0766 3.62076 25.244 3.89158C25.4113 4.16239 25.5 4.47447 25.5 4.79283V11.65C25.5 11.9683 25.4113 12.2804 25.244 12.5512C25.0766 12.822 24.8371 13.0409 24.5524 13.1833C24.2676 13.3257 23.9488 13.3859 23.6318 13.3573C23.3147 13.3287 23.0118 13.2124 22.7571 13.0214L18.6429 9.93569V6.50712Z",
    stroke: "#232428",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/IconVideo.d77e2270d478ac6db34a13bae8a5ce97.svg";
export { ForwardRef as ReactComponent };